const PREFIX = 'SEARCH';

export const OPEN_MODAL = `${PREFIX}_OPEN_MODAL`;
export const CLOSE_MODAL = `${PREFIX}_CLOSE_MODAL`;
